import { Button } from "@newsela/angelou";
import PropTypes from "prop-types";

import withTrackEvent from "@/eventStream/withTrackEvent";
import { buttonCss } from "./ChallengesTeacherTab.style";

const propTypes = {
  activeTab: PropTypes.string,
  handleOptionSelection: PropTypes.func,
  tabName: PropTypes.string,
};

const ChallengesTeacherTab = ({
  activeTab,
  handleOptionSelection,
  tabName,
}) => {
  const isSelected = activeTab === tabName;
  const ButtonWithTrackEvent = withTrackEvent(Button);
  const eventProperties = {
    objectType: "User",
    actionName: "Interact",
    event_type: "click",
    streamProperties: {
      component_type: "ChallengesTeacherTab",
      description: `Change Challenge Active Tab to ${tabName} `,
    },
  };

  return (
    <ButtonWithTrackEvent
      __cssFor={{ root: buttonCss(isSelected) }}
      id={`challenge-tab-${tabName}`}
      flavor={isSelected ? "POLAR_SECONDARY" : "TERTIARY"}
      onClick={() => handleOptionSelection(tabName)}
      role="tab"
      {...eventProperties}
      dataProps={{
        "data-qa-selector": `IRC: Change Challenge Active Tab to ${tabName}`,
      }}
    >
      {tabName}
    </ButtonWithTrackEvent>
  );
};

ChallengesTeacherTab.propTypes = propTypes;

export default ChallengesTeacherTab;
